import { Component, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'fs-tab-bar-offline',
  styleUrls: ['./tab-bar-offline.sass'],
  templateUrl: './tab-bar-offline.component.html',
  encapsulation: ViewEncapsulation.None
})

export class TabBarOfflineComponent {
  @Input() titlePage: string;
}
